import React from 'react';
import classNames from 'classnames';

const STATICS = ['role'];
function hoistStatics(source, target) {
  STATICS.forEach(staticProp => {
    if (Object.prototype.hasOwnProperty.call(source, staticProp)) {
      target[staticProp] = source[staticProp];
    }
  });
}

function createCell(WrappedCell) {
  const Cell = props => (
    <WrappedCell
      {...props}
      className={classNames('Table-cell', props.className, {
        'Table-cell--xSmall': props.size === 'xs',
        'Table-cell--small': props.size === 's',
        'Table-cell--large': props.size === 'l',
        'Table-cell--xLarge': props.size === 'xl',
        'Table-cell--sortable': typeof props.sort === 'string',
        'Table-cell--center': props.center,
        'Table-cell--clickable': props.clickable,
        'Table-cell--split': props.split,
        'u-hideBelowMD': props.hideBelowMD,
        'u-hideBelowXS': props.hideBelowXS,
      })}
      tabIndex="0"
    />
  );

  /**
   * Hoisting statics from the wrapped cell to the new cell component. For
   * example, each WrappedCell component has a role property and we want to
   * persist that on the new returned cell.
   */
  hoistStatics(WrappedCell, Cell);

  Cell.displayName = `Cell(${WrappedCell.displayName || WrappedCell.name})`;
  return Cell;
}

export default createCell;
